<script setup lang="ts">
import { useGlobalShortcuts } from '~/composables/shortcuts'

const open = ref(false)

const { onViewShortcuts, all: groups } = useGlobalShortcuts()

onViewShortcuts(() => {
  open.value = !open.value
})
</script>

<template>
  <USlideover
    v-model:open="open"
    :overlay="false"
    inset
    title="Keyboard shortcuts"
  >
    <template #body>
      <UCommandPalette :groups="groups" placeholder="Search shortcuts" />
    </template>
  </USlideover>
</template>
